/**
 * Wishlist Cart Integration
 * Ensures cart drawer refreshes when items are added from wishlist
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistCartIntegration);
  } else {
    initWishlistCartIntegration();
  }

  function initWishlistCartIntegration() {
    // Listen for clicks on wishlist "Add to Cart" buttons
    document.addEventListener('click', handleWishlistAddToCart, true);

    // Also listen for fetch requests to cart/add.js (Shopify's add to cart endpoint)
    interceptCartAddRequests();
  }

  /**
   * Handle clicks on wishlist add to cart buttons
   */
  function handleWishlistAddToCart(event) {
    // Check if clicked element is within a wishlist drawer
    const wishlistDrawer = event.target.closest('.wishlists-drawer__inner, .atw-drawer_inner, wishlists-drawer, [class*="wishlist-drawer"]');
    
    if (!wishlistDrawer) return;
    
    // Check if it's an add to cart button
    const addToCartBtn = event.target.closest('button.fish-wishlist-button--primary, .fish-wishlist-button--primary, button[class*="add-to-cart"], [class*="atc-button"]');
    
    // Also check for buttons with text "Add to Cart" or similar
    const buttonText = event.target.closest('button')?.textContent?.toLowerCase() || '';
    const isAddToCartText = buttonText.includes('add to cart') || buttonText.includes('add to');
    
    if (addToCartBtn || isAddToCartText) {
      // Wait a bit for the cart API call to complete, then refresh
      setTimeout(() => {
        refreshCartDrawer();
      }, 600);
    }
  }

  /**
   * Intercept fetch requests to cart/add.js to detect when items are added
   */
  function interceptCartAddRequests() {
    const originalFetch = window.fetch;
    let wishlistAddInProgress = false;
    
    // Set flag when wishlist drawer is open
    const observer = new MutationObserver(() => {
      const wishlistDrawer = document.querySelector('.wishlists-drawer__inner:not([style*="display: none"]), .atw-drawer_inner:not([style*="display: none"]), wishlists-drawer:not([hidden])');
      wishlistAddInProgress = !!wishlistDrawer;
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'hidden', 'class']
    });
    
    window.fetch = function(...args) {
      const url = args[0];
      
      // Check if this is a cart/add.js request
      if (typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'))) {
        const wasFromWishlist = wishlistAddInProgress;
        
        // Call original fetch
        const fetchPromise = originalFetch.apply(this, args);
        
        // After the request completes, refresh cart drawer if from wishlist
        if (wasFromWishlist) {
          fetchPromise
            .then((response) => {
              if (response.ok) {
                setTimeout(() => {
                  refreshCartDrawer();
                }, 400);
              }
              return response;
            })
            .catch((error) => {
              console.error('[Wishlist Cart Integration] Error adding to cart:', error);
              return Promise.reject(error);
            });
        }
        
        return fetchPromise;
      }
      
      // For all other requests, use original fetch
      return originalFetch.apply(this, args);
    };
  }

  /**
   * Refresh the cart drawer by dispatching theme events and calling getCart()
   */
  function refreshCartDrawer() {
    // Dispatch theme:cart:added event (theme listens to this)
    const cartAddedEvent = new CustomEvent('theme:cart:added', {
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(cartAddedEvent);
    
    // Also dispatch cart:updated event (some scripts listen to this)
    const cartUpdatedEvent = new CustomEvent('cart:updated', {
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(cartUpdatedEvent);
    
    // Try to get the cart element and call getCart() method
    const cartElement = document.querySelector('cart-element[data-cart-drawer], [data-cart-drawer]');
    if (cartElement && typeof cartElement.getCart === 'function') {
      cartElement.getCart();
    } else {
      // Fallback: fetch cart and update manually
      fetchCartAndUpdate();
    }
  }

  /**
   * Fallback: Fetch cart data and trigger update
   */
  function fetchCartAndUpdate() {
    const cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
    
    fetch(cartUrl, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(cart => {
        // Dispatch theme:cart:update event with cart data
        const cartUpdateEvent = new CustomEvent('theme:cart:update', {
          bubbles: true,
          detail: { cart }
        });
        document.dispatchEvent(cartUpdateEvent);
        
        // Also try to find and update cart element
        const cartElement = document.querySelector('cart-element, [data-cart-drawer]');
        if (cartElement && typeof cartElement.getCart === 'function') {
          cartElement.getCart();
        }
      })
      .catch(error => {
        console.error('[Wishlist Cart Integration] Error fetching cart:', error);
      });
  }
})();

